module.exports = __webpack_public_path__ + "static/media/loader-square.7e7f1ab4.svg";